import { OverRideLocaleType } from "@/locales/locales-interface";

export const enLocale: OverRideLocaleType = {
  DateOfSignature: "Date of signature",
  DateOfForming: "Date of forming",
  SelectLearningMaterials: "Select learning materials",
  Save: "Save",
  Amount: "Amount",
  Responsible: "Responsible",
  Number: "Number",
  Delete: "Delete",
  DocumentInArchive: "Document in archive",
  NotSigned: "Not signed",
  Price: "Price",
  NotSelected: "Not selected",
  Contractor: "Contractor",
  Contract: "Contract",
  Signed: "Signed",
  Action: "Action",
  Name: "Name",
  DriveUsedTotal: "Drive (Used/Total)",
  Head: "Head",
  MaximumPasswordLength: "Maximum password length",
  ShouldAPasswordContainUppercaseLatinCharacters:
    "Should a password contain uppercase Latin characters?",
  ShouldAPasswordContainNumbers: "Should a password contain numbers?",
  ShouldAPasswordContainLowercaseLatinCharacters:
    "Should a password contain lowercase Latin characters?",
  MinimumPasswordLength: "Minimum password length",
  DriveTitle: "Drive title",
  Edit: "Edit",
  Size: "Size",
  Login: "Login",
  Company: "Company",
  User: "User",
  Formed: "Formed",
  EnterAmountRUB: "Enter amount, RUB",
  Payments: "Payments",
  AddPayment: "Add payment",
  Actions: "Actions",
  Account: "Account",
  EnterTheSumOfPaymentRUB: "Enter the sum of payment, RUB",
  Cancel: "Cancel",
  Date: "Date",
  Balance: "Balance",
  PaidIn: "Paid in",
  EnterDirectionLearningTitle: "Enter Direction learning title",
  Description: "Description",
  EnterDescriptionOfDirectionLearning:
    "Enter description of direction learning",
  Apply: "Apply",
  Free: "Free",
  Used: "Used",
  Available: "Available",
  Files: "Files",
  Total: "Total",
  SettlementAccount: "Settlement account",
  Website: "Website",
  FullName: "Name",
  ShortName: "Short name",
  RussianClassificationOnObjectsOfAdministrativeDivisionOKATO:
    "Russian Classification on Objects of Administrative Division (OKATO)",
  RussianClassificationOfEconomicActivitiesOKVED:
    "Russian Classification of Economic Activities (OKVED)",
  AddCommissionMember: "Add commission member",
  Phones: "Phones",
  PatronymicName: "Patronymic name",
  CorrespondentAccount: "Correspondent account",
  PositionOfHead: "Position of head",
  BankIdentificationCodeBIC: "Bank Identification Code (BIC)",
  CompanyDetails: "Company details",
  TaxRegistrationReasonCodeKPP: "Tax Registration Reason Code (KPP)",
  SelectNewHeadOfCompany: "Select new head of company",
  TaxpayerIdentificationNumberTIN: "Taxpayer Identification Number (TIN)",
  RegisteredAddress: "Registered address",
  RussianNationalClassifierOfBusinessesAndOrganizationsOKPO:
    "Russian National Classifier of Businesses and Organizations (OKPO)",
  Settings: "Settings",
  Position: "Position",
  ActiveCompany: "Active",
  Surname: "Surname",
  FullNameOfCompanysHead: "Full name of company's head",
  TimeZone: "Time zone",
  CommissionMembers: "Commission members",
  ActualAddress: "Actual address",
  EnterTheName: "Enter the name",
  Bank: "Bank",
  ActsOnTheBasisOf: "Acts on the basis of",
  FullNameOfCompanysHeadInTheGenitive:
    "Full name of company's head in the genitive",
  PrimaryStateRegistrationNumberPSRN:
    "Primary State Registration Number (PSRN)",
  HeadOfCompany: "Head of company",
  CreateCompanyEmployee: "Create company employee",
  EditUser: "Edit user",
  DeleteUserFromCompany: "Delete user from company",
  Phone: "Phone",
  Commission: "Commission",
  AddEmployee: "Add employee",
  NotAvailable: "Not available",
  UsersNotFound: "Users not found",
  ImportOfUsers: "Import users",
  Created: "Created",
  Created_male: "Created",
  InviteUsers: "Invite users",
  Warning: "Warning",
  ContactPhone: "Contact phone",
  Role: "Role",
  Employee: "Employee",
  Employees: "Employees",
  FirstNameSurnameOrEmailatLeastCharacters:
    "First name, surname or email (at least 3 characters)",
  SeeMore: "See more",
  AddUserInCompany: "Add user in company",
  Confirm: "Confirm",
  DoYouReallyWantToRemoveAUserFromYourCompany:
    "Do you really want to remove a user from your company?",
  Modified: "Modified",
  PhoneNumber: "Phone number",
  Accountant: "Accountant",
  LearningRequestManager: "Learning Request manager",
  Teacher: "Teacher",
  NumberOfUsersInTheContract: "Number of users in the contract",
  AddFromLearningRequest: "Add from Learning Request",
  EnterYourPaymentOption: "Enter your payment option",
  EnterManually: "Enter manually",
  PrepaymentOf: "Prepayment of 50%",
  ContractorType: "Contractor type",
  Type: "Type",
  FullPostpayment: "Full post-payment",
  AllContracts: "All contracts",
  LegalPerson: "Legal person",
  PhysicalPerson: "Physical person",
  ContractAddendum: "Contract Addendum",
  ContractAddendums: "Contract Addendums",
  EnterContractNumber: "Enter contract number",
  FullPrepayment: "Full prepayment",
  PaymentTerms: "Payment terms",
  AddFromLearningMaterials: "Add from Learning materials",
  SelectContract: "Select contract",
  AmountRUB: "Amount, RUB",
  Students: "Students",
  SourceOfPayment: "Source of payment",
  PriceRUB: "Price, RUB",
  ViewAllStudents: "View all students",
  Status: "Status",
  StartTypingALearningRequestNumber: "Start typing a Learning Request number",
  LearningMaterialManager: "Learning material/Manager",
  ResultsNotFound: "Results not found",
  LearningRequest: "Learning Request",
  Add: "Add",
  Back: "Back",
  RecordedWebinar: "Recorded webinar",
  Webinar: "Webinar",
  PriceForOneStudent: "Price for one student",
  EnterUsersFirstNameSurnameAndEmail:
    "Enter user's First name, surname and email",
  Course: "Course",
  SelectType: "Select type",
  LearningMaterial: "Learning material",
  NotSpecified: "Not specified",
  KaluginaLyudmilaProkofievna: "Kalugina Lyudmila Prokofievna",
  CompanysFullName: "Company's Full name",
  EgDirector: "e.g., director",
  Contacts: "Contacts",
  ShortCompanyName: "Short company name",
  OfKaluginaLyudmilaProkofievna: "of Kalugina Lyudmila Prokofievna",
  EgCompanyStatute: "e.g., company statute",
  StudentsCitizenshipcountryCodeOnRussianClassificationOfCountriesOfTheWorldOKSM:
    "Student's citizenship (country code on Russian classification of countries of the world (OKSM)",
  EducationalInstitutionName: "Educational institution name",
  Comment: "Comment",
  DateOfIssueOfAHESPEDocumentDateOfIssueOfAHigherEducationSecondaryProfessionalEducationDocument:
    "Date of issue of a HE/SPE document (Date of issue of a Higher Education/Secondary professional education document)",
  Gender: "Gender",
  RegistrationAddress: "Registration address",
  SurnameIsStatedInADipHEDipSPESurnameIsStatedInADiplomaOfHigherEducationSecondaryProfessionalEducation:
    "Surname is stated in a DipHE/DipSPE (Surname is stated in a Diploma of Higher Education/Secondary professional education)",
  DateOfBirth: "Date of birth",
  RegistrationNumberOfAHESPEDocument:
    "Registration number of a HE/SPE document",
  PassportIssuedBy: "Passport issued by",
  SeriesOfAHESPEDocument: "Series of a HE/SPE document",
  FromTheEducationCenter: "From the Education Center",
  PassportSeries: "Passport series",
  PassportNumber: "Passport number",
  DateOfPassportIssuance: "Date of passport issuance",
  IndividualInsuranceAccountNumberSNILS:
    "Individual insurance account number (SNILS)",
  HESPEDocumentNumber: "HE/SPE document number",
  LevelOfEducation: "Level of education",
  UserContactPerson: "User/Contact person",
  ContactPerson: "Contact person",
  ContractorResponsible: "Contractor/Responsible",
  ContractorsNameOrTINatLeastCharacters:
    "Contractor's name or TIN (at least 3 characters)",
  Select: "Select",
  ContractorNotFound: "Contractor not found",
  ListOfFoundContactors: "List of found contactors",
  IfValidalityPeriodIsUnlimitedEnter:
    "If validality period is unlimited, enter 0",
  ProfessionQualificationName: "Profession (Qualification) name",
  FISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining:
    "FIS FRDO",
  FurtherEducationalProgram: "Further Educational Program",
  FinalDocument: "Final document",
  DocumentsValidityPeriodMonths: "Document's validity period, months",
  Published: "Published",
  Enter: "Enter",
  IntegratedGroupsOfSpecialities: "Integrated groups of specialities",
  LearningDirection: "Learning direction",
  NumberOfHours: "Number of hours",
  RandomOrderOfLeaningCourse: "Random order of learning course",
  FieldOfProfessionalActivity: "Field of professional activity",
  Title: "Title",
  NotAttachedLectures: "Not attached lectures",
  DoYouReallyWantToDetachALectureFromThisCourse:
    "Do you really want to detach a lecture from this course?",
  Detach: "Detach",
  Viewed: "Viewed",
  EditCourse: "Edit course",
  Lectures: "Lectures",
  UpdateDate: "Update date",
  ModifiedDate: "Modified date",
  NameTeacher: "Name/Teacher",
  Hours: "Hours",
  CreationDate: "Creation date",
  NotFound: "Not found",
  LearnerProgress: "E-journal for learning progress",
  RegistrationDate: "Registration date",
  StartDate: "Start date",
  UserIsntAttached: "User isn't attached",
  EnterFullName: "Enter Full name",
  AddStudents: "Add students",
  NumberOfLessons: "Number of lessons",
  NotStudents: "Not students",
  AtLeastCharacters: "At least 3 characters",
  IfYouRemoveAStudentFromTheCourseAllAssociatedTrainingDocumentsAreDeletedDeactivateAStudentForClosingAccess:
    "If you remove a student from the course, all associated training documents are deleted. Deactivate a student for closing access",
  Clear: "Clear",
  OpenAccess: "Open access",
  IfAUserIsDeactivatedAccessToTheCoursesLearningMaterialsIsClosed:
    "If a user is deactivated, access to the course's learning materials is closed",
  RegisteredTill: "Registered till",
  NotStudentsInProgress: "Not students in progress",
  RegisteredFrom: "Registered from",
  EmailFullName: "Email, Full name",
  Email: "Email",
  SelectFile: "Select file",
  SelectedFile: "Selected file",
  CopyFieldCodesInTheDocxDocumentBelowIsAnExampleOfFillingTheDocumentTemplateTokensAreHighlightedInYellowForClarityYouDontHaveToDoThat:
    "Copy field codes in the docx document. Below is an example of filling the document template. Tokens are highlighted in yellow for clarity, you don't have to do that",
  TemplateType: "Template type",
  DocumentTemplateTitle: "Document template title",
  File: "File",
  DocumentTemplateFile: "Document template file",
  SelectTemplate: "Select template",
  DownloadFile: "Download file",
  CreateNew: "Create new",
  CreateNewTemplate: "Create new template",
  Generate: "Generate",
  ActionsNotAvailable: "Actions not available",
  TemplateTitle: "Template title",
  Tokens: "Tokens",
  RepeatedTokens: "Repeated tokens",
  SelectEntityTemplate: "Select entity template",
  AlwaysShowAFixedNumberOfCharacters:
    "Always show a fixed number of characters",
  ForExampleUC: "For example, -UC",
  StartingSequenceNumber: "Starting sequence number",
  Prefix: "Prefix",
  Preview: "Preview",
  EnterNumberOfCharactersInANumber: "Enter number of characters in a number",
  Postfix: "Postfix",
  StudentsInProgress: "Students in progress",
  SelectCourse: "Select course",
  ReasonOfTestingKnowledge: "Reason of testing knowledge",
  ThereAreNotStudentsInTheSelectedCourseOrATrainingProtocolHasAlreadyCreated:
    "There are not students in the selected course or a training protocol has already created",
  ThereAreNotCommissionMembersInYourCompany:
    "There are not commission members in your company",
  Secretary: "Secretary",
  Chairman: "Chairman",
  TrainingProtocolNumber: "Training protocol number",
  CourseResponsible: "Course/Responsible",
  Updated: "Updated",
  Practice: "Practice",
  Test: "Test",
  Training: "Training",
  AccessesToSelectedCourseOnSelectedDateHaventBeenProvided:
    "Accesses to selected course on selected date haven't been provided",
  CompletionDate: "Completion date",
  OrderNumber: "Order number",
  NoStudentsStartingToLearnACourse: "No students starting to learn a course",
  StudentInProgress: "Student in progress",
  NotStudentsInProgressInTheCourse: "Not students in progress in the course",
  TestIsntAttached: "Test isn't attached",
  PracticeAssignmentIsntAttached: "Practice assignment isn't attached",
  EditContract: "Edit contract",
  Order: "Order",
  DeleteCompletionOrder: "Delete completion order",
  AvailableStudentsInProgress: "Available students in progress",
  AvailableStudents: "Available students",
  DocumentIsArchived: "Document is archived",
  AllDelete: "All delete",
  Move: "Move",
  CuttingFiles: "Cutting files",
  Format: "Format",
  PasteTheCopiedFilesInTheCurrentDirectory:
    "Paste the copied files in the current directory",
  Copy: "Copy",
  DoYouReallyWantToDeleteTheseFiles:
    "Do you really want to delete these files?",
  CopiedFiles: "Copied files",
  FilesAreNotFoundInThisDirectory: "Files are not found in this directory",
  SearchEnterAtLeastCharacters: "Search, enter at least 3 characters",
  LastFiles: "Last files",
  Rename: "Rename",
  EnterName: "Name",
  More: "More",
  CopyLinkToAFile: "Copy link to a file",
  DocumentPoweredBy: "document, powered by",
  MicrosoftOffice: "Microsoft Office",
  OfficeOnline: "Office Online",
  ThisIsAnEmbedded: "This is an embedded",
  CreateFolder: "Create folder",
  FolderName: "Folder name",
  UploadFiles: "Upload files",
  DragAndDropFileHere: "Drag and drop file here",
  FilesNotSelected: "Files not selected",
  AddFiles: "Add files",
  FileManager: "File manager",
  DeleteLearningMaterial: "Delete learning material",
  View: "View",
  FileName: "File name",
  UploadingDate: "Uploading date",
  AddLearningMaterial: "Add learning material",
  TheFederalBudget: "The federal budget",
  ExpiryDateinMonths: "Expiry date (in months)",
  TrainingProtocol: "Training protocol",
  EvidenceOfLoss: "Evidence of loss",
  PaidEducation: "Paid education",
  NotInEducationalOrganization: "Not in educational organization",
  Not: "Not",
  TitleOfDiplomaThesis: "Title of diploma thesis",
  RecipientsName: "Recipient's name",
  RecipientsSurname: "Recipient's surname",
  FulltimeparttimeStudy: "Full-time/part-time study",
  ReferenceFromTheDepartmentOfInternalAffairs:
    "Reference from the Department of Internal Affairs",
  RegistrationNumber: "Registration number",
  Duplicate: "Duplicate",
  IssueDate: "Issue date",
  ReferenceFromTheFireAuthorities: "Reference from the Fire Authorities",
  PlaceOfInternship: "Place of internship",
  LocalTraining: "Local training",
  DuplicateSettings: "Duplicate settings",
  FormOfReceivingEducationAtTheTimeOfTheEducationalRelationshipTermination:
    "Form of receiving education at the time of the educational relationship termination",
  DocumentNumberForModification: "Document number for modification",
  Search: "Search",
  Other: "Other",
  FulltimeStudy: "Full-time study",
  FormNumber: "Form number",
  FormSeries: "Form series",
  RegionalBudget: "Regional budget",
  SourceOfFunding: "Source of funding",
  InEducationalOrganization: "In educational organization",
  ParttimeStudy: "Part-time study",
  AwardedQualificationLevelClassCategory:
    "Awarded qualification level, class, category",
  FormEducation: "Form education",
  EvidenceOfDestroyingDocuments: "Evidence of destroying documents",
  SelectTrainingProtocol: "Select training protocol",
  Original: "Original",
  ExchangeDueToFalseInformationProviding:
    "Exchange due to false information providing",
  RecipientsPatronymic: "Recipient's Patronymic",
  ExchangeDueToDamage: "Exchange due to damage",
  AnnouncementInTheNewspaper: "Announcement in the newspaper",
  ExchangeConfirmation: "Exchange confirmation",
  EnterIfADocumentsDurationPeriodIsUnlimited:
    "Enter 0, if a document's duration period is unlimited",
  EducationDocumentName: "Education document name",
  ValidTill: "Valid till",
  Issued: "Issued by",
  Student: "Student",
  DownloadFISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining:
    "Download FIS FRDO (Federal information system 'The Federal Register of Data on Education Documents and (or) about Qualification, Documents on Training')",
  NotResults: "Not results",
  InArchive: "In archive",
  ResultsOnTheEnteredDataNotFound: "Results on the entered data not found",
  ThisActionCannotBeUndoneAreYouSureYouWantToDelete:
    "This action cannot be undone. Are you sure you want to delete?",
  MoveInArchive: "Move in archive",
  EnterMaskName: "Enter mask name",
  SelectNumbering: "Select numbering",
  SorryResultsNotFound: "Sorry, results not found",
  SumUpTheResults: "Sum up the results",
  FailedTest: "Failed test",
  Check: "Check",
  ViewMistakes: "View mistakes",
  CheckingAssignments: "Checking assignments",
  PracticeAssignments: "Practice assignments",
  Courses: "Courses",
  TrainedStudentsForMonth: "Trained students for month",
  LearningRequests: "Learning requests",
  Managers: "Managers",
  CourseRating: "Course rating",
  OverviewOn: "Overview as of",
  SalesForMonthPcs: "Sales for month, pcs",
  RevenueRUB: "Revenue, RUB",
  FinancialReport: "Financial report",
  TeacherAccount: "Teacher account",
  Learn: "Learn",
  NotLearningMaterials: "Not learning materials",
  Webinars: "Webinars",
  NumberOfLectures: "Number of lectures",
  FinalTest: "Final test",
  DateAndTime: "Date and time",
  Participants: "Participants",
  CompletedLearningRequests: "Completed learning requests",
  AmountOnTheSignedCertificatesOfCompletedWorks:
    "Amount on the signed certificates of completed works",
  Billed: "Billed",
  CertificatesOfCompletedWorks: "Certificates of completed works",
  Income: "Income",
  BillsRUB: "Bills, RUB",
  Bills: "Bills",
  AmountOnTheIssuedCertificatesOfCompletedWorks:
    "Amount on the issued certificates of completed works",
  Paid: "Paid",
  Debt: "Debt",
  ForSignature: "For signature",
  CertificatesOfCompletedWorksRUB: "Certificates of completed works, RUB",
  GoToPayments: "Go to payments",
  ForYesterday: "For yesterday",
  InProcessing: "In processing",
  Done: "Done",
  WaitingForPrepayment: "Waiting for prepayment",
  TrainingCompleted: "Training completed",
  GoToLearningRequests: "Go to learning requests",
  DocumentsPrepared: "Documents prepared",
  NotProcessed: "Not processed",
  Contractors: "Contractors",
  LearningRequestIsFormedFrom: "Learning Request is formed from",
  LearningRequestIsFormedTill: "Learning Request is formed till",
  RecordedWebinars: "Recorded webinars",
  Unpublished: "Unpublished",
  ViewConductedWebinars: "View conducted webinars",
  WebinarSchedule: "Webinar schedule",
  NotUpcomingWebinar: "Not upcoming webinar",
  Upgrades: "Upgrades",
  AllowedDomains: "Allowed domains",
  NameDescription: "Name/Description",
  AccessRights: "Access rights",
  YouDontHaveTheGeneratedKeys: "You don't have the generated keys",
  PermittedIP: "Permitted IP",
  DeleteKey: "Delete key",
  PermittedAPI: "Permitted API",
  WidgetIsCreated: "Widget is created",
  WebsiteAddress: "Website address",
  ShowDescription: "Show description",
  EnterAColorInHEXFormat: "Enter a color in HEX format",
  ColorOfTheTypesOfLearningMaterials:
    "Color of the types of learning materials",
  WidgetContent: "Widget content",
  CommentToWebform: "Comment to Webform",
  ShowToplevelTitles: "Show top-level titles",
  NotificationAfterSuccessfulLearningRequestSending:
    "Notification after successful Learning Request sending",
  SelectALearningRequestManager: "Select a Learning Request manager",
  BackgroundColor: "Background color",
  YouAreAbleToCopyTheCodeOnlyNow: "You are able to copy the code only now",
  ThisManagerWillBeResponsibleOnTheLearningRequest:
    "This manager will be responsible on the Learning Request",
  PasteTheCodeBelowIntoTheContainerOnYourWebsiteWhereYouWantToShowAListOfLearningMaterials:
    "Paste the code below into the container on your website where you want to show a list of learning materials",
  CopyWidgetCode: "Copy widget code",
  MainButtonsColor: "Main buttons color",
  ColorOfAFontOfDirection: "Color of a font of direction",
  ShowNumberOfHours: "Show number of hours",
  ColorOfCoursesNamePriceHours: "Color of courses name, price, hours",
  ShowPrice: "Show price",
  Manager: "Manager",
  SelectTheLearningMaterialsForAddingToTheWebsiteSeveralWidgetsCanBeAddedOnTheDifferentPagesOfOneWebsite:
    "Select the learning materials for adding to the Website. Several widgets can be added on the different pages of one website",
  ExampleGooglecom: "Example google.com",
  EnterHEXColor: "Enter HEX color",
  DeleteWidget: "Delete widget",
  EditWidget: "Edit widget",
  SelectUsers: "Select users",
  SendInvitations: "Send invitations",
  Useremail: "user.email",
  MaximumScore: "Maximum score",
  StartedCompleted: "Started/Completed",
  Result: "Result",
  Duration: "Duration",
  TestResult: "Test result",
  SessionIsActive: "Session is active",
  TestSessionTime: "Test session time",
  SessionFrom: "Session from",
  Scored: "Scored",
  Opened: "Opened",
  Completed: "Completed",
  LecturesTest: "Lecture's test",
  FormedFrom: "Formed from",
  FormedTill: "Formed till",
  NumberLearningRequest: "Number Learning Request",
  EnterNumber: "Enter number",
  RUB: "0 RUB",
  LearningRequestProfile: "Learning Request profile",
  DeleteFromList: "Delete from list",
  EnterNumberOfLearningRequest: "Enter number of Learning Request",
  NumberOfStudentsLearningACourseNumberOfStudentsInProgress:
    "Number of students learning a course /  Number of students in progress",
  ViewListOfTheStudents: "View list of the students",
  ViewListOfTheStudentsLearningACourseViewListOfStudentsInProgress:
    "View list of the students learning a course / View list of students in progress",
  NumberOfStudents: "Number of students",
  AddingStudents: "Adding students",
  Events: "Events",
  SelectAStatusOfTheLearningRequest: "Select a status of the Learning Request",
  TheFollowingStatuses: "The following statuses",
  SelectAll: "Select all",
  Attach: "Attach",
  ListOfAddedCourses: "List of added courses",
  ListOfAvailableCourses: "List of available courses",
  SearchForAvailableCourses: "Search for available courses",
  CourseNameatLeastCharacters: "Course name (at least 3 characters)",
  EditCourseMaterial: "Edit course material",
  CreateCourseMaterial: "Create course material",
  AdditionalLearningMaterials: "Additional learning materials",
  LectureText: "Lecture text",
  Slides: "Slides",
  Video: "Video",
  Text: "Text",
  PublicationSetting: "Publication Setting",
  LectureSlides: "Lecture slides",
  LecturePages: "Lecture pages",
  EditLecture: "Edit lecture",
  All: "All",
  NotLectures: "Not lectures",
  EditPage: "Edit page",
  CreateLecturePage: "Create lecture page",
  LearningMaterials: "Learning materials",
  AdditionOfLearningMaterials: "Addition of learning materials",
  Sales: "Sales",
  ControlPanel: "Control Panel",
  Reports: "Reports",
  Logout: "Logout",
  LearningResults: "Learning Results",
  EducationalDocuments: "Educational documents",
  Assessment: "Assessment",
  NotUsers: "Not users",
  EmailOrFullName: "Email or Full name",
  NotStarted: "Not Started",
  NotStarted_male: "Not Started",
  CompleteTraining: "Complete training",
  PhoneNumberIsNotSpecified: "Phone number is not specified",
  AvailableOnlyForCourses: "Available only for courses",
  LearningRequestType: "Learning Request type",
  AddStudentInProgress: "Add student in progress",
  RegisterUser: "Register user",
  Register: "Register",
  SelectWebinar: "Select webinar",
  Registration: "Registration",
  SelectLearningMaterialType: "Select learning material type",
  SelectRecordedWebinar: "Select recorded webinar",
  Users: "Users",
  ListOfUsersInLearningRequest: "List of users in Learning Request",
  AttachedFiles: "Attached files",
  WriteYourAnswer: "Write your answer",
  Submit: "Submit",
  AddFile: "Add file",
  CoursePracticeAssignment: "Course Practice assignment",
  Unknown: "Unknown",
  Failed: "Failed",
  Assignment: "Assignment",
  DeletedUser: "Deleted user",
  Passed: "Passed",
  TeachersComment: "Teacher's comment",
  AnswerIsSubmitted: "Answer is submitted",
  Answer: "Answer",
  UsersAnswer: "User's answer",
  Attached: "Attached",
  AssignmentsConditions: "Assignment's conditions",
  YouNeedToAddADirectLinkURLToAVideoShortLinksCouldntBeUsed:
    "You need to add a direct link URL to a video. Short links couldn't be used",
  AddALinkToTheSourceOrSelectAFileFromTheList:
    "Add a link to the source or select a file from the list",
  Content: "Content",
  ShowFiles: "Show files",
  EditRecordedWebinar: "Edit recorded webinar",
  MainInformation: "Main information",
  Documents: "Documents",
  Education: "Education",
  DeleteStudent: "Delete student",
  DateOfStudentsRegistration: "Date of student's registration",
  Upgrade: "Upgrade",
  Create: "Create",
  SelectTermType: "Select term type",
  SelectTest: "Select test",
  AttachPracticeAssignment: "Attach practice assignment",
  AttachTest: "Attach test",
  CourseDoesntIncludeAPracticeAssignment:
    "Course doesn't include a practice assignment",
  DontAttachAPracticeAssignment: "Don't attach a practice assignment",
  AddQuestionsInNewTest: "Add questions in new test",
  Questions: "Questions",
  NumberOfQuestionsInTest: "Number of questions in test",
  NumberOfAttemptsToPassTestPerDay: "Number of attempts to pass test per day",
  SetToShowAllQuestions: "Set 0, to show all questions",
  MinNumberOfCorrectAnswersToPassTest:
    "Min number of correct answers to pass test",
  Active: "Active",
  EnterForNoTimeLimits: "Enter 0 for no time limits",
  EditingAndPublishing: "Editing and publishing",
  CommentsToAnswers: "Comments to answers",
  DisplayQuestionsRandomly: "Display questions randomly",
  TestSessionTimeinMinutes: "Test session time (in minutes)",
  SetForNoTimeLimits: "Set 0 for no time limits",
  ShowAnswerComments: "Show answer comments",
  PracticeTest: "Practice test",
  RandomOrderOfQuestions: "Random order of questions",
  NumberOfAttemptsToPassTestInTotal: "Number of attempts to pass test in total",
  AnswersReceived: "Answers received",
  Started: "Started",
  Started_male: "Started",
  Correct: "Correct",
  QuestionNumber: "Question number",
  Incorrect: "Incorrect",
  Print: "Print",
  TestResults: "Test results",
  Next: "Next",
  Question: "Question",
  StartTest: "Start test",
  EachAnswerShouldBeStartedOnANewLineAndWithOneAsterisk:
    "Each answer should be started on a new line and with one asterisk *",
  ToCommentOnTheAnswersAddTheSymbolOnALineEndOfAnswer:
    "To comment on the answers — add the symbol /// on a line end of answer",
  MarkEachNewQuestionWithThreeAsterisks:
    "Mark each new question with three asterisks ***",
  ToAddANewParagraphToTheQuestionGoToANewLine:
    "To add a new paragraph to the question —  go to a new line",
  CheckCorrectnessOfTheGeneratedQuestionsBeforeAdding:
    "Check correctness of the generated questions before adding",
  ToIdentifyTheCorrectAnswersAddAnAsteriskWithAPlus:
    "To identify the correct answers — add an asterisk with a plus *+",
  EditOrChangeExamplesOfQuestions: "Edit or change examples of questions",
  Requirements: "Requirements",
  SaveQuestions: "Save questions",
  CommentToAnswer: "Comment to answer",
  Answers: "Answers",
  SaveQuestion: "Save question",
  AddAnswer: "Add answer",
  EnterAnswer: "Enter answer",
  AddNewQuestion: "Add new question",
  BulkAdd: "Bulk Add",
  AddCopied: "Add Copied",
  Sort: "Sort",
  ShowComments: "Show comments",
  Sorting: "Sorting",
  RequiredMinCorrectAnswersToPassTest:
    "Required min correct answers to pass test",
  TotalAttempts: "Total attempts",
  QuestionsInTest: "Questions in test",
  AttemptsPerDay: "Attempts per day",
  CopyAllQuestions: "Copy all questions",
  TestTitle: "Test title",
  CopyALoginAccess: "Copy a login access",
  Password: "Password",
  EducationalProgram: "Educational program",
  EducationalProgramAndDocuments: "Educational program and documents",
  Companies: "Companies",
  Document: "Document",
  PostalAddress: "Postal address",
  CompanyName: "Company name",
  AboutMe: "About me",
  ListOfFoundUsers: "List of found users",
  ListOfFoundStudents: "List of found students",
  FirstNameSurnameEmail: "First name, surname, Email",
  SelectPhoto: "Select photo",
  ChangeAvailableSpace: "Change available space",
  PatronymicInDativeCase: "Patronymic in dative case",
  Male: "Male",
  ChangePassword: "Change password",
  ActiveUser: "Active user",
  EnterNewPasswordAgain: "Enter new password again",
  SurnameInDativeCase: "Surname in dative case",
  ResetPassword: "Reset password",
  MainData: "Main data",
  EnterOldPassword: "Enter old password",
  TypeIfYouWantToChangePassword: "Type if you want to change password",
  Female: "Female",
  FirstNameInDativeCase: "First name in dative case",
  Photo: "Photo",
  EnterNewPassword: "Enter new password",
  NotSelectedGender: "Not selected gender",
  AccessForCompany: "Access for company",
  EditCompanysUser: "Edit company's user",
  EditCertificateOfCompletedWorks: "Edit certificate of completed works",
  Editing: "Editing",
  PriceFrom: "Price from",
  FormingDateFrom: "Formed from",
  EnterPrice: "Enter price",
  SignedFrom: "Signed from",
  CertificatesOfCompletedWorksNotFound:
    "Certificates of completed works not found",
  SearchForNumber: "Search for Number",
  FormationDateTill: "Formed till",
  PriceTill: "Price till",
  SignedTill: "Signed till",
  Template: "Template",
  CertificateOfCompletedWorks: "Certificate of completed works",
  ContractorphysicalPerson: "Contractor (physical person)",
  CompanysName: "Company's name",
  Profiles: "Profiles",
  SearchForName: "Search for Name",
  CreateDirectionOfLearning: "Create Direction of learning",
  DirectionsOfLearningList: "Directions of learning List",
  DirectionsOfLearning: "Directions of learning",
  NewLearningDirection: "New learning direction",
  CreateCompany: "Create Company",
  SelectPreset: "Select preset",
  CreateUser: "Create User",
  SharingPersonalData: "6.4. Sharing personal data",
  TheMinimumNecessaryDataProvidedByTheUsersForCommunicationNamepossiblyUseAFictitiousNameMobileNumberAndorEmailAddress:
    "the minimum necessary data provided by the Users for communication: name (possibly use a fictitious name), mobile number and/or email address",
  TheUsersPersonalDataIsCollectedOnTheWebsiteByEnteringDataByTheUserOnHisOwnInitiativeAtTheTimeOfAppealingToTheWebsiteAdministrationOrTheWebsiteAccordingToTheUsersSettings:
    "6.2.1.The User's personal data is collected on the Website by entering data by the User on his own initiative at the time of appealing to the Website Administration or the Website according to the User's settings",
  ComplianceOfThePurposesOfPersonalDataProcessingWithThePurposesDefinedInAdvanceAndDeclaredUnderTheCollectionOfPersonalDataAndAlsoWithTheAuthorityOfTheWebsiteAdministration:
    "compliance of the purposes of personal data processing with the purposes defined in advance and declared under the collection of personal data, and also with the authority of the Website Administration",
  TheAdministrationWebsiteTakesTechnicalOrganizationalAndLegalMeasuresToEnsureTheProtectionOfTheUsersPersonalDataFromUnauthorizedOrAccidentalAccessToThatDestructionModificationBlockingCopyingDisseminationAndAlsoFromOtherIllegalActions:
    "7.1. The Administration Website takes technical, organizational and legal measures to ensure the protection of the User's personal data from unauthorized or accidental access to that, destruction, modification, blocking, copying, dissemination and also from other illegal actions.",
  LimitationOfTheRules: "8.	Limitation of the Rules",
  OtherInformationAboutTheUsersProcessingByTheWebsiteAdministration:
    "5.2.Other information about the Users processing by the Website Administration",
  GeneralRegulations: "1. General Regulations",
  TheAdministrationWebsiteDoesntTakeResponsibilityForTheActionsOfThirdPartiesWhoHaveGainedAccessToInformationAboutTheUserThroughUsingTheInternetAndWebsiteServicesAndForConsequencesOfUsageInformationThatIsInherentlyAvailableForAnyInternetUser:
    "8.2.	The Administration Website doesn’t take responsibility for the actions of third parties who have gained access to information about the User through using the Internet and Website services and for consequences of usage information that is inherently available for any Internet user",
  TheRelationsConnectedToProcessingCollectionStorageDisseminationAndProtectionOfTheWebsiteUsersAreRegulatedByThisRegulationOtherOfficialDocumentsOfTheWebsiteAdministrationAndTheCurrentLegislationOfTheRussianFederation:
    "1.2.The relations connected to processing collection, storage, dissemination and protection of the Website users are regulated by this Regulation, other official documents of the Website Administration and the current legislation of the Russian Federation",
  TheContentOfPersonalData: "5.	The content of personal data",
  SharingUsersPersonalDataWithStateBodieslocalSelfgovernmentBodiesIsCarriedOutInAccordanceWithTheProcedureProvidedForByLaw:
    "6.4.3. Sharing User’s personal data with state bodies (local self-government bodies) is carried out in accordance with the procedure provided for by law",
  ProcessingInformationAboutUsers: "6.Processing information about users",
  LawfulnessOfThePurposesAndTypesOfPersonalDataProcessing:
    "lawfulness of the purposes and types of personal data processing",
  ReceivedInformationAsAResultOfTheUsersActionsOnTheWebsite:
    "received information as a result of the User’s actions on the Website",
  PurposesOfProcessingInformation: "4.Purposes of processing information",
  InformationAutomaticallyReceivedWhenAccessingTheWebsiteUsingBookmarkscookies:
    "Information automatically received when accessing the Website using bookmarks (cookies)",
  DestructionOfUsersPersonalDataIsDestroyedAtTheWrittenRequestOfTheUserTheRequestMustContainIdentificationDataThatDirectlyIndicatesThatTheInformationBelongsToThisUser:
    "6.5.1.Destruction of user’s personal data is destroyed at the written request of the User. The request must contain identification data that directly indicates that the information belongs to this User.",
  ConditionsAndPurposesOfProcessingPersonalData:
    "2.Conditions and purposes of processing personal data",
  DestructionOfPersonalData: "6.5.Destruction of personal data",
  TheUserAgreesToTheTermsAndConditionsOfTheRegulationByRegisteringSendingMessagesApplicationsLeadsOtherMessagesUsingTheWebFormsAndWebsiteContactMeansUsingWebsiteAndItsServicesMustBeImmediatelyTerminatedIfTheUserDoesntAgreeWithTheTermsAndConditionsOfTheRegulationsTheUserHimselfherselfIsResponsibleForThis:
    "1.3.The User agrees to the Terms and Conditions of the Regulation by registering, sending messages, applications, leads, other messages using the web forms and website contact means. Using Website and its services must be immediately terminated if the User doesn't agree with the Terms and Conditions of the Regulations. The User himself  (herself) is responsible for this.",
  PersonalDataIsNotSharedWithAnyPersonsExceptInTheCasesSpecifiedByThisRegulation:
    "6.4.1.Personal data is not shared with any persons except in the cases specified by this Regulation",
  StorageAndUsingOfPersonalData: "6.3.Storage and using of personal data",
  PersonalDataProcessingIsCarriedOutOnTheBasisOfTheFollowingPrinciples:
    "6.1.Personal data processing is carried out on the basis of the following principles",
  TheProcedureOfImplementationAndChangingOfTheRegulation:
    "3.The procedure of implementation and changing of the Regulation",
  TheAdministrationWebsiteRecommendsToTheUsersTakeResponsibilityForSolutionToQuestionRegardingTheAmountOfInformationAboutThemselvesSharingFromTheWebsite:
    "8.3.The Administration Website recommends to the Users take responsibility for solution to question regarding the amount of information about themselves sharing from the Website.",
  TheWebsiteAdministrationProcessesInformationAboutTheUsersIncludingTheirPersonalDataForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwners:
    "4.1.The Website Administration processes information about the Users including their personal data for completion obligations between the Website Administration and the Users within a providing information about activity and work of structural subdivisions of the website owners.",
  InformationNecessaryForIdentificationOfTheUserForAccessToWebsiteServices:
    "information necessary for identification of the User for access to website services",
  TheWebsiteAdministrationDoesntVerifyTheValidityOfReceivedcollectedInformationAboutTheUsersExceptingWhenTheAdministrationWebsiteHasToCompleteObligationsToTheUser:
    "1.4.The Website Administration doesn't verify the validity of received (collected) information about the Users, excepting when the Administration Website has to complete obligations to the User.",
  ApplicationsUsedByTheUsersOnTheWebsiteAreHostedAndMaintainedByThirdPartiesdevelopersWhoActIndependentlyOfTheWebsiteAdministrationAndDontActOnBehalfOrOnTheAuthorityOfTheWebsiteAdministrationTheUsersMustGetInformedThemselvesAboutTheRulesOfServiceDeliveryAndThePersonalDataProtectionPolicyOfSuchThirdPartiesdevelopersBeforeUsingTheRelevantApplications:
    "6.4.2. Applications used by the Users on the Website are hosted and maintained by third parties (developers) who act independently of the Website Administration and don’t act on behalf or on the authority of the Website Administration. The Users must get informed themselves about the rules of service delivery and the personal data protection policy of such third parties (developers) before using the relevant applications.",
  PersonalDataProcessingByTheWebsiteAdministrationIsCarriedOutForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwnersInAccordanceWithArticleOfFederalLawOfJulyFLAboutPersonalDataTheSeparateUsersConsentToTheProcessingOfThePersonalDataIsNotRequiredAccordingToASubparagraphClauseArticleOfThisLawTheWebsiteAdministrationHasTheRightForProcessingPersonalDataWithoutANotificationOfTheAuthorizedBodyOnTheProtectionOfTheRightsOfSubjectsOfPersonalData:
    "2.1. Personal data processing by the Website Administration is carried out for completion obligations between the Website Administration and the Users within a providing information about activity and work of structural subdivisions of the website owners. In accordance with Article 6 of Federal law of July 27, 2006 №152-FL “About personal data” the separate user's consent to the processing of the personal data is not required. According to a subparagraph 2 clause 2 article 22 of this Law the Website Administration has the right for processing personal data without a notification of the authorized body on the protection of the rights of subjects of personal data.",
  TheWebsiteAdministrationHasTheRightToMakeChangesToTheRegulationTheWebsiteAdministrationNotifiesTheUsersAboutTheRegulationsChangesByPostingTheNewVersionOnWebsiteAtThePermanentAddressInThisCaseThePreviousVersionsOfTheRegulationBecomeInvalid:
    "3.3.The Website Administration has the right to make changes to the Regulation. The Website Administration notifies the Users about the Regulation’s changes by posting the new version on Website at the permanent address. In this case, the previous versions of the Regulation become invalid.",
  TheUserAdditionallyOnHisOwnInitiativeProvidesOtherPersonalDataByUsingTheRelevantSectionsAndResourcesOfTheWebsite:
    "6.2.3. The User additionally on his own initiative provides other personal data by using the relevant sections and resources of the Website",
  PersonalDataIsProvidedByTheUserVoluntarilyThatMeansAConsentToProcessingByTheWebsiteAdministrationAndIncludes:
    "5.1. Personal data is provided by the User voluntarily that means a consent to processing by the Website Administration and includes:",
  InAdditionTheWebsiteAdministrationProcessesOtherInformationAboutTheUsersThatIncludes:
    "In addition, the Website Administration processes other information about the Users that includes",
  TheseRulesDoNotApplyToAThirdPartysActionsAndInternetResources:
    "8.1.These Rules do not apply to a third party’s actions and Internet resources",
  ThisRegulationIsAnOfficialDocumentOfWebsiteAdministrationPostedOnThisWebsiteAndDefinesTheProcedureForTheProcessingAndProtectionOfPersonalDataOfTheWebsiteUsershereinafterTheUsersAndWebsiteServiceshereinafterTheWebsite:
    "1.1.This Regulation is an official document of Website Administration posted on this website and defines the procedure for the processing and protection of personal data of the website users  (hereinafter – the  Users) and Website services (hereinafter – the Website).",
  ComplianceWithTheAmountAndCharacterOfProcessedPersonalDataTypesOfPersonalDataProcessingWithThePurposesOfPersonalDataProcessing:
    "compliance with the amount and character of processed personal data, types of personal data processing with the purposes of personal data processing;",
  Integrity: "integrity;",
  ThisRegulationComesIntoForceFromPostingOnWebsiteAndRemainInForceWithoutLimitOfTimeUntilReplacingItWithANewRegulation:
    "3.1.This Regulation comes into force from posting on website and remain in force without limit of time, until replacing it with a new Regulation.",
  MeasuresToProtectUserInformation: "7.Measures to protect user information",
  OtherDataincludingGenderAgeDateOfBirthAddressEtcIsProvidedByTheUserAtWillAndIfNecessarySuchDataForCommunicationWithTheUserAndActivitiesRelatedToDeliveryOfServiceOrProductsToTheUser:
    "other data (including gender, age, date of birth, address etc.) is provided by the User at will and if necessary such data for communication with the user and activities related to delivery of service or products to the User",
  CollectionOfPersonalData: "6.2. Collection of personal data",
  PurposesOfProcessingPersonalDataIncludeReceivingInformationMailingsDocumentsAndMaterialsIncludingAdvertisingByTheUserProcessingUsersOrdersWhichAreIntendedToReceiveGoodsAndServicesUserConsultingSupport:
    "2.2. Purposes of processing personal data include: receiving information, mailings, documents and materials, including advertising by the User, processing user’s orders which are intended to receive goods and services, user consulting support",
  ReceivedInformationAsAResultOfOtherUsersActionsOnTheWebsite:
    "received information as a result of other users’ actions on the Website;",
  TheCurrentVersionOfTheRegulationIsAPublicDocumentAvailableToAnyInternetUser:
    "3.2.The current version of the Regulation is a public document, available to any Internet user.",
  PersonalDataStorageIsCarriedOutOnlyOnElectronicMediaAndProcessedUsingAutomatedSystemsExceptInCasesWhenNonautomatedProcessingOfPersonalDataIsNecessaryForComplyingWithTheLegalRequirements:
    "6.3.1.Personal data storage is carried out only on electronic media and processed using automated systems, except in cases when non-automated processing of personal data is necessary for complying with the legal requirements.",
  StandardDataAutomaticallyReceivedByTheServerWhenAccessingTheWebsiteAndTheUsersFurtherActionsIPAddressOfTheHostTypeOfTheUsersOperatingSystemWebsitePagesVisitedByTheUser:
    "Standard data automatically received by the server when accessing the Website and the User’s further  actions (IP address of the host, type of the user's operating system, Website pages visited by the user);",
  ForgotPassword: "Forgot password?",
  Reset: "Reset",
  YourLoginOrEmail: "Your login or Email",
  LoginOrEmail: "Login or Email",
  PersonalDataProtectionRegulation: "Personal data protection regulation",
  LearningManagementSystem: "Learning management system",
  EditBill: "Edit bill",
  AmountTill: "Amount till",
  PaymentsRUB: "Payments, RUB",
  AmountFrom: "Amount from",
  AllBills: "All bills",
  BillsNotFound: "Bills not found",
  BillNumber: "Bill number",
  EnterBillNumber: "Enter bill number",
  ReceiptsOnAccount: "Receipts on account",
  BalanceRUB: "Balance, RUB",
  RemainingDebt: "Remaining debt",
  TotalOfAllReceipts: "Total of all receipts",
  Bill: "Bill №",
  PaidInRUB: "Paid In, RUB",
  DebtRUB: "Debt, RUB",
  EditCompany: "Edit company",
  NewCompany: "New company",
  InformationAboutEducationalOrganization:
    "Information about educational organization",
  DocumentType: "Document type",
  NumberOfUsers: "Number of users",
  AddCertificateOfCompletedWorks: "Add Certificate of completed works",
  LearningMaterialsNotSelected: "Learning materials not selected",
  AddBill: "Add bill",
  YouCantAddABillWithoutLearningMaterials:
    "You can't add a bill without learning materials",
  YouCantAddACertificateOfCompletedWorksWithoutLearningMaterials:
    "You can't add a certificate of completed works without learning materials",
  NotAttachments: "Not attachments",
  ContractorEditing: "Contractor editing",
  NameTIN: "Name, TIN",
  ContractorsNotFound: "Contractors not found",
  NewContractor: "New contractor",
  CourseEditing: "Course editing",
  AdditionalInformation: "Additional information",
  InformationAboutDocuments: "Information about documents",
  CoursesNotFound: "Courses not found",
  YouTeach: "You teach",
  YouLearn: "You learn",
  NewCourse: "New course",
  NewSCORM: "New SCORM",
  NewCourseOfTraining: "New course of training",
  FileNotSelected: "File not selected",
  UploadCourse: "Upload course",
  Uncompress: "Uncompress",
  FolderTitle: "Folder title",
  NewSCORMCourse: "New SCORM course",
  SelectSCORMArchive: "Select SCORM archive",
  DoYouReallyWantToCompleteTheTrainingInTheCurrentCourse:
    "Do you really want to complete the training in the current course?",
  PracticeAssignment: "Practice assignment",
  IfTheTestIsntAttachedAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial:
    "If the test isn't attached, a student in progress will not have access to the next learning materials until he (she) opens the current material",
  IfTheTestIsAttachedToTheLectureAStudentWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccefully:
    "If the test is attached to the lecture, a student will not have access to the next learning materials untill he (she) takes the test succefully",
  IfTheTestIsntAttachedAStudentWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial:
    "If the test isn't attached, a student will not have access to the next learning materials until he (she) opens the current material",
  PracticeAssignmentIsCompleted: "Practice assignment is completed",
  DocumentExpiryDateMonths: "Document expiry date, months",
  StartPracticeAssignment: "Start Practice assignment",
  AttachTheLectureToTheCourse: "Attach the lecture to the course",
  NameOfTheFieldOfProfessionalActivity:
    "Name of the field of professional activity",
  TestSuccessfullyPassed: "Test successfully passed",
  AdditionalProfessionalProgram: "Additional professional program",
  TableOfContents: "Table of contents",
  IfTheTestIsAttachedToTheLectureAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccessfully:
    "If the test is attached to the lecture, a student in progress will not have access to the next learning materials untill he (she) takes the test successfully",
  NextLecture: "Next lecture",
  Complete: "Complete",
  DoYouReallyWantToCompleteTheCurrentLecture:
    "Do you really want to complete the current lecture?",
  PreviousLecture: "Previous lecture",
  DocumentTemplateEditing: "Document template editing",
  NewDocumentTemplate: "New document template",
  EnterATitleOfTheDocumentTemplate: "Enter a title of the document template",
  OrderOfEnrollment: "Order of enrollment",
  OrderOfCompletion: "Order of completion",
  GenerateFinalDocumentsForAllUsers: "Generate Final documents for all users",
  CreateFinalDocuments: "Create Final documents",
  EditTrainingProtocol: "Edit training protocol",
  EnterTrainingProtocolNumber: "Enter training protocol number",
  TainingProtocolsNotFound: "Taining protocols not found",
  NewTrainingProtocol: "New training protocol",
  OrderOfEnrollmentEditing: "Order of enrollment editing",
  EnterOrderNumber: "Enter order number",
  OrdersOfEnrollment: "Orders of enrollment",
  NewOrderOfEnrollment: "New order of enrollment",
  PleaseTryAgainOrContactTechnicalSupport:
    "Please try again or contact Technical Support",
  SorrySomethingWentWrong: "Sorry, something went wrong",
  OrderOfCompletionEditing: "Order of completion editing",
  OrdersOfCompletion: "Orders of completion",
  NewOrderOfCompletion: "New order of completion",
  EndDate: "End Date",
  DocumentNumber: "Document number",
  RecipientsFullName: "Recipient's full name",
  Expires: "Expires",
  RetrainingIsCarriedOutOnTheBasisOfAEducationalDocument:
    "Retraining is carried out on the basis of a Educational document",
  ToList: "To list",
  DuplicateInformation: "Duplicate information",
  EditFinalDocument: "Edit final document",
  UnloadingParameters: "Unloading parameters",
  PageNumber: "Page number",
  FinalDocuments: "Final documents",
  HowManyToGenerate: "How many to generate",
  NumberOfElementsForDownload: "Number of elements for download",
  YouDontHaveFinalDocuments: "You don't have final documents",
  FISFRDOAPE: "FIS FRDO APE",
  IssuedTill: "Issued till",
  FISFRDOPT: "FIS FRDO PT",
  IssuedFrom: "Issued from",
  SelectStudent: "Select student",
  NewFinalDocument: "New final document",
  IMPORTANT: "IMPORTANT",
  SelectACategory: "Select a category",
  AlsoBeSureYouHaveAFolder: "Also be sure you have a folder",
  InCompanysFiles: "In company's files",
  ImportCourses: "Import courses",
  WhenImportingYouShouldSpecifyTheFieldParameters:
    "When importing you should specify the field parameters",
  EnterTheDomains: "Enter the domains",
  EnterADomain: "Enter a domain",
  CopyKey: "Copy key",
  Token: "Token",
  GenerateKey: "Generate key",
  YouCanCopyATokenOnlyNow: "You can copy a token only now",
  APIKeyGenerating: "API Key Generating",
  YourAPIKeyIsGenerated: "Your API Key is generated",
  EnterIPOneByOneOrSeveralSeparatedByCommas:
    "Enter IP (One by one or several separated by commas)",
  EnterIP: "Enter IP",
  CreateAWidget: "Create a widget",
  Integration: "Integration",
  Widget: "Widget",
  NotificationForTheForm: "Notification for the form",
  NewWidgetOfCompany: "New widget of company",
  EditCompanysWidget: "Edit company's widget",
  DownloadTemplate: "Download template",
  ImportCompanyUsersFromCsv: "Import company users from csv",
  RequirementsToAFile: "Requirements to a file",
  Import: "Import",
  TheUserTableShouldConsistOfColumnsInTheFollowingOrder:
    "The user table should consist of columns in the following order",
  SpecifyTheDelimiter: "Specify the delimiter",
  TheFileEncodingShouldBeWindows: "The file encoding should be Windows-1251",
  ThePasswordMustBeAtLeastCharactersAndMustContainNumberUppercaseLetterLowercaseLetter:
    "The password must be at least 8 characters and must contain 1 number, 1 uppercase letter, 1 lowercase letter",
  TheFileEncodingShouldBeWindowsCyrillic:
    "The file encoding should be Windows-1251 (Cyrillic)",
  MustBeFilled: "Must be filled",
  EnterSurname: "Enter surname",
  AddToList: "Add to list",
  UserList: "User list",
  EnterPatronymic: "Enter patronymic",
  CourseName: "Course name",
  AllTrainingStatuses: "All training statuses",
  ForExampleIvanov: "For example, Ivanov",
  Successful: "Successful",
  Unsuccessful: "Unsuccessful",
  GeneralInformation: "General information",
  AddToLearningRequest: "Add to Learning request",
  RemoveFromLearningRequest: "Remove from Learning request",
  AddStatus: "Add status",
  NewLecture: "New lecture",
  Lecture: "Lecture",
  TestPassedSuccessfully: "Test passed successfully",
  ToLectureList: "To lecture list",
  EditingLearningRequest: "Editing Learning request №",
  Invitations: "Invitations",
  LearningRequestStatus: "Learning request status",
  EditLearningRequest: "Edit Learning request",
  NewLearningRequest: "New Learning request",
  Version: "Version",
  New: "New",
  Old: "Old",
  ConfirmPassword: "Confirm password",
  EditingPracticeAssignment: "Editing Practice assignment",
  PracticeAssignmentsNotFound: "Practice assignments not found",
  PendingVerification: "Pending verification",
  SentForFinalization: "Sent for reworking",
  CreatePracticeAssignment: "Create Practice assignment",
  PracticeAssignmentResults: "Practice assignment results",
  NewPracticeAssignment: "New Practice assignment",
  AssignmentToLearningMaterial: "Assignment to learning material",
  WriteANewAnswer: "Write a new answer",
  RequiredFinalization: "Required finalization",
  MyPracticeAssignmentResults: "My practice assignment results",
  YouHaventTakenAPracticeAssignmentOfThisCourse:
    "You haven't taken a practice assignment of this course",
  EditingRecordedWebinar: "Editing Recorded webinar",
  NewRecordedWebinar: "New recorded webinar",
  RecordedWebinarNameatLeastCharacters:
    "Recorded webinar name (at least 3 characters)",
  UsersWithAccessToARecordedWebinar: "Users with access to a recorded webinar",
  CloseAccessForUser: "Close access for user",
  DocumentName: "Document name",
  CreateDocumentType: "Create Document Type",
  NewDocumentType: "New Document Type",
  TermName: "Term name",
  TermType: "Term type",
  NewFISFRDO: "New FIS FRDO",
  EditingTest: "Editing Test",
  QuestionsUploading: "Questions uploading",
  Tests: "Tests",
  EnterTestName: "Enter test name",
  TestsNotFound: "Tests not found",
  NewTest: "New test",
  SelectLecture: "Select lecture",
  SelectStudentInProgress: "Select student in progress",
  TrainingMaterialWasntSelectedInTheSearchFilterOrStudentsHaventTakenTheTests:
    "Training material wasn't selected in the search filter or students haven't taken the tests",
  TestingDate: "Testing Date",
  NotLectureInSelectedCourse: "Not lecture in selected course",
  TestingFrom: "Testing from",
  ResultsOfTests: "Results of tests",
  TestType: "Test type",
  TestingTill: "Testing till",
  TryAgain: "Try again",
  CompleteTheTest: "Complete the test",
  TestToLearningMaterial: "Test to learning material",
  EditingProfile: "Editing profile",
  EditProfile: "Edit Profile",
  EditingWebinar: "Editing Webinar",
  NewWebinar: "New webinar",
  WebinarEndDate: "Webinar end date",
  WebinarEndTime: "Webinar end time",
  PriceMin: "Price min.",
  Max: "Max.",
  Host: "Host",
  PublicationStatus: "Publication status",
  WebinarStartDate: "Webinar Start Date",
  PriceMax: "Price max.",
  Min: "Min.",
  Hosted: "Hosted",
  WebinarNameatLeastCharacters: "Webinar name (at least 3 characters)",
  Online: "Online",
  Planned: "Planned",
  EnableAWebinarRecording: "Enable a webinar recording",
  MaximumNumberOfStudents: "Maximum number of students",
  SelectWebinarPlatform: "Select Webinar platform",
  UsersWithAccessToWebinar: "Users with access to webinar",
  LinkToTheSource: "Link to the source",
  TurnOffPublicChatForUsers: "Turn off public chat for users",
  Own: "Own",
  StartTime: "Start Time",
  DisableAMicrophoneUsingForUsers: "Disable a microphone using for users",
  Thirdparty: "Third-party",
  EndTime: "End Time",
  UserNotFound: "User not found",
  DisableAWebcamUsingForUsers: "Disable a webcam using for users",
  PasteTheLinkToTheSourceWhereTheWebinarWillBeHosted:
    "Paste the link to the source where the webinar will be hosted",
  Completion: "Completion",
  RecordsWillBeDeletedAfterDays: "Records will be deleted after 14 days",
  Platform: "Platform",
  TheRecordIsBeingPrepared: "The record is being prepared",
  EditWebinar: "Edit Webinar",
  WebcamRecording: "Webcam recording",
  ScreenRecording: "Screen recording",
  Start: "Start",
  CheckForRecordedWebinars: "Check for recorded webinars",
  RecordedWebinarsNotFound: "Recorded webinars not found",
  StudentsNumber: "Students number",
  WatchWebinar: "Watch webinar",
  FirstNameAddressEmailAndorPhoneAreProvidedByTheUserForFeedbackAndForStandardWorkOnTheWebsiteIsNotRequired:
    "6.2.2.First name, address, Email and/or phone are provided by the User for feedback and for standard work on the Website is not required",
  Export: "Export",
  Contracts: "Contracts",
  Yes: "Yes",
  No: "No",
  Records: "Records",
  Record: "Record",
  CreateRecord: "Create record",
  FullNameUser: "User full name",
  FreeDiskSpace: "Free disk space",
  Source: "Source",
  Hide: "Hide",
  Show: "Show",
  UserName: "Name",
  PasswordsDoNotMatch: "Passwords do not match",
  Error: "Error",
  TheInformationHasBeenSuccessfullyChanged:
    "The information has been successfully changed",
  UnknownError: "Unknown error",
  DoNotAttachTheTest: "Do not attach the test",
  ChangesHaveBeenSuccessfullySaved: "Changes have been successfully saved",
  AddQuestionsToTheTest: "Add questions to the test",
  TheQuestionCannotBeEmpty: "The question cannot be empty",
  TheAnswerChoiceCannotBeEmpty: "The answer choice cannot be empty",
  AtLeastOneAnswerMustBeCorrect: "At least one answer must be correct",
  Learning: "Learning",
  Pause: "Pause",
  Success: "Success",
  Fail: "Fail",
  Canceled: "Cancel",
  UseTheKeyboardArrowsToSelectDate: "Use the keyboard arrows to select a date",
  UserHasAlreadyCompletedTrainingIfYouNeedToRetrain:
    "The user has already completed training. If you need to retrain, add the person to the list again.",
  TestFailed: "Test failed",
  TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest:
    "The number of created test questions cannot be less than the actual number of questions in the test",
  ThisIsTheFirstParagraphOfTheQuestion:
    "*** This is the first paragraph of the question",
  SecondParagraphOfTheQuestion: "Second paragraph of the question",
  AnswerDesc: "* Answer",
  CorrectAnswerCommentOnTheAnswer:
    "*+ Correct answer /// Comment on the answer",
  PushkinWasBornIn: "*** Pushkin was born in ...",
  YesterdayDesc: "*Yesterday",
  Reply: "Reply",
  ChooseAtLeastOneAnswer: "Choose at least one answer",
  TimeExpired: "Time expired",
  NotLimited: "Not limited",
  AQuestionCannotContainLessThanTwoAnswers:
    "A question cannot contain less than two answers",
  QuestionAdded: "Question added",
  SortingHasBeenChanged: "Sorting has been changed",
  NotAttached: "Not Attached",
  AccessDenied: "Access Denied",
  AccessGranted: "Access granted",
  NotComplete: "Not Completed",
  CompletedUnsuccessfully: "Completed unsuccessfully",
  Access: "Access",
  FirstName: "First name",
  NoDateSpecified: "Дата не указана",
  PendingReview: "Pending review",
  NotFilled: "Not Filled",
  AlreadyCreated: "Already Created",
  NewContract: "New Contract",
  TheTrainingCanBeCompletedByTheResponsibleTeacher:
    "TheTrainingCanBeCompletedByTheResponsibleTeacher",
  SomeRequiredFieldsAreNotFilledIn: "Some required fields are not filled in",
  SearchByEmail: "Search by email",
  SuccessfullyDeleted: "Successfully deleted",
  ChooseAtLeastOneCourse: "Choose at least one course",
  ASlideCannotBeEmpty: "A slide cannot be empty",
  Untitled: "Untitled",
  ProfessionalEducation: "Professional Education",
  AdditionalProfessionalEducation: "Additional Professional Education",
  Indefinitely: "No time limit",
  InvitationsHaveBeenSuccessfullySent:
    "Invitations have been successfully sent",
  Activated: "Activated",
  NotActivated: "Not activated",
  ShowMore: "Show more",
  ThankYouYourLearningRequestWasSuccessfullyCreated:
    "Thank you! Your learning request was successfully created!",
  IfAnythingGoesWrongOrYouHaveQuestions:
    "If anything goes wrong or you have questions about the course, call or write to our contact information - we'll help.",
  CodeCopiedSuccessfully: "Code Copied Successfully",
  InsertTheCodeBelowBeforeTheClosingTag:
    "Insert the code below before the closing tag",
  onYourSite: "on your site",
  MostPopular: "Most Popular",
  NoTest: "No test",
  NoPractice: "No practice",
  TheTestHasNotStarted: "The test has not started",
  FromTheArchive: "From the archive",
  NextMonth: "Next month",
  PreviousMonth: "Previous month",
  NextYear: "Next year",
  PreviousYear: "Previous year",
  Day: "Day",
  IncorrectEmailFormat: "Incorrect Email format",
  AllValuesOfTheFieldsAtTheMomentWillBeSaved:
    "All values of the fields at the moment will be saved. The document will not be available for editing",
  DoYouReallyWantToRemoveTheDocumentFromTheArchive:
    "Do you really want to remove the document from the archive?",
  DoYouReallyWantToMoveTheDocumentToTheArchive:
    "Do you really want to move the document to the archive?",
  MinimumNumberOfCharactersEntered: "Minimum number of characters entered",
  ThePasswordMustConsistOfNumbersAndUpperAndLowerCaseLatinLetters:
    "The password must consist of numbers and upper and lower case Latin letters",
  ThisFieldIsRequired: "This field is required",
  UnableToRetrieveUserInformation: "Unable to retrieve user information",
  YouAnsweredCorrectlyTo: "You answered correctly to",
  outOf: "out of",
  questionsOf: "questions",
  YouMustSelectAtLeastOneOption: "You must select at least one option",
  LectureTest: "Lecture test",
  CourseTest: "Course test",
  LogIn: "Login",
  AttachAStudentToTheUser: "Attach a student to the user",
  UserPasswordSettings: "User password settings",
  BasicInformation: "Basic information",
  StructureAndManagementBodies: "Structure and management bodies",
  EducationalStandards: "Educational standards",
  ManagementPedagogicalStaff:
    "Management. Pedagogical (scientific and pedagogical) staff",
  MaterialAndTechnicalSupportAndEquipmentOfTheEducationalProcess:
    "Material and technical support and equipment of the educational process",
  ScholarshipsAndOtherTypesOfMaterialSupport:
    "Scholarships and other types of material support",
  FinancialAndEconomicActivities: "Financial and economic activities",
  VacantPlacesForAdmission: "Vacant places for admission (transfer)",
  AccessibleEnvironment: "Accessible environment",
  InternationalCooperation: "International cooperation",
  PaidEducationalServices: "Paid educational services",
  Citizenship: "Citizenship",
  Passport: "Passport",
  NewStudent: "New Student",
  YouCannotCreateInvoiceAmountGreaterThanContractAmount:
    "You cannot create an invoice amount greater than the contract amount",
  TheDiskVolumeCannotBeLessThanTheOccupiedSpace:
    "The disk volume cannot be less than the occupied space",
  EnterTheAmount: "Enter the amount",
  OneOrMoreFieldsAreEmpty: "One or more fields are empty",
  SelectStudents: "Select Students",
  AtLeastOneUserMustBeSelected: "At least one user must be selected",
  GeneratePDF: "Generate PDF",
  TheLinkToChangeYourPasswordWasSentToTheEmail:
    "The link to change your password was sent to the email",
  ImportedUsers: "Imported Users",
  CreateStudents: "Create Students",
  CreateLearningRequest: "Create a Learning Request",
  Lesson: "Lesson",
  DocumentNumbering: "Document Numbering",
  CreatingANumbering: "Creating a numbering",
  DocumentTemplates: "Document templates",
  TrainingProtocols: "Training protocols",
  UploadCSVFileWithListOfYourUsersToTheFileManager:
    "Upload a CSV file with a list of your users to the file manager",
  IfTheUsernameAndPasswordFieldsAreNotFilled:
    "If the username and password fields are not filled in, they will be automatically generated",
  FastDocumentCreation: "Fast document creation",
  MyPracticalAssignments: "My practical assignments",
  MyTestResults: "My test results",
  ApplicationProfiles: "Application profiles",
  WaitingForPayment: "Waiting for payment",
  TrainingInProgress: "Training in progress",
  CancelAll: "Cancel all",
  TheDateAreAsDayMonthYear:
    "The dates (birthday, educationDate and whenPassportIssued) are as Day.Month.Year",
  TheGenderIsIndicatedByNumbers:
    "The gender is indicated by numbers: 1 - Male, 0 - Female",
  UserSuccessfullyDisconnectedFromTheVideo:
    "User successfully disconnected from the video",
  UserSuccessfullyAddedToVideo: "User successfully added to video",
  RegistrationLinksWereSentToEmail: "Registration links were sent to Email",
  TheUserIsNotAnActiveStudentInTheCourse:
    "The user is not an active student in the course",
  TheChangesYouMadeMayNotBeSaved: "The changes you made may not be saved!",
  MaximumNumberOfUsersWithAccessToTheWebinar:
    "Maximum number of users with access to the webinar",
  PleaseSpecifyTheMaximumNumberOfUsersWhoHaveAccessToTheWebinar:
    "Please specify the maximum number of users who have access to the webinar",
  YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart:
    "You can enter the webinar room only 10 minutes before the start",
  EntriesAreDeletedAfterDays: "Entries are deleted after 14 days",
  TheFormedFieldIsRequired: "The 'Formed' field is required",
  SelectAFile: "Select a file",
  IncorrectDocumentFormatOnlyDocxIsAllowed:
    "Incorrect document format, only docx is allowed",
  CompletedAndPassed: "Completed and passed",
  Waived: "Waived",
  Abandoned: "Abandoned",
  Satisfied: "Satisfied",
  Paste: "Paste",
  ImportContractors: "Import contractors",
  ImportOfContractors: "Import of contractors",
  ImportContractorsFromCsv: "Import contractors from csv",
  TheContractorsTableShouldConsistOfColumnsInTheFollowingOrder:
    "The contractors table should consist of columns in the following Order",
  UploadCSVFileWithListOfYourContractorsToTheFileManager:
    "Upload CSV file with list of your contractors to the file manager",
  AskAllQuestionsInPracticeTest: "Ask all questions in practice test",
  DoNotLimitTheTimeOfPracticeTest: "Do not limit the time of practice test",
  ShowAnswersImmediatelyInPracticeTest:
    "Show answers immediately in practice test",
  YouCanOnlyUseScvFile: "You can only use csv file",
  CopiedQuestions: "Copied questions",
  LoginLink: "Login link",
  AccessCopied: "Access copied",
  docGenerate: "Generate document",
  RussianLanguage: "Russian",
  EnglishLanguage: "English",
  Language: "Language",
  WebinarNotStarted: "Not started",
  Notice: "Notice",
  Ended: "Ended",
  Month: "Month",
  Year: "Year",
  FullYear: "Full year",
  BindToDate: "Bind to date",
  UpdateFrequency: "Update frequency",
  ThisAnswerIsCorrectYouDidntChooseTheCorrectAnswer:
    "This answer is correct, you didn't choose the correct answer",
  DomainMail: "Domain email",
  TrainingGroups: "Training Groups",
  TrainingGroup: "Training Group",
  TheStartDateOfTrainingOn: "The start date of training on",
  TheStartDateOfTrainingFrom: "The start date of training from",
  NewGroup: "New Group",
  NoData: "No data",
  Loading: "Loading",
  Home: "Home",
  GenerateAccesses: "Generate accesses",
  Configuration: "Configuration",
  EmployeeDeleted: "Employee deleted",
  DisabledCompany: "Disabled company",
  ChooseStudents: "Choose students",
  TokensList: "List of tokens",
  CopyToTheCurrentFolder: "Copy to the current folder",
  MoveToTheCurrentFolder: "Move to the current folder",
  PageNotFound: "Page not found",
  PageAccessDenied: "Access denied",
  DeleteSelectedFiles: "Delete selected files",
  FormedContracts: "FormedContracts",
  FormedBills: "FormedBills",
  FormedActs: "FormedActs",
  FormedOrdersOfEnrollments: "Formed orders of enrollment",
  FormedOrdersOfCompletions: "Formed orders of completions",
  FormedTrainingProtocols: "Formed training protocols",
  FormedFinalDocuments: "Formed final documents",
  NumberOfApplicationsWithCurrentProfile:
    "Number of applications with current profile",
  Indefinite: "Indefinite",
  AdditionalFeatures: "Additional features",
  NotDefined: "Not defined",
  Aborted: "Aborted",
  RegistrationExistMessage:
    "A user with this name, date of birth and SNILS exists",
  Update: "Update",
  ShortNameFisFrdo: "FIS FRDO",
  AvailableSpacesForStudents: "Available spaces for students",
  DirectorNameInitials: "Director name initials",
  DirectorPositionGenitive: "Director position genitive",
  LastLogin: "Last login",
  RequiredData: "Необходимо заполнить данные",
  NewAgent: "New agent",
  Agents: "Agents",
  Agent: "Agent",
  IsPercent: "Is percent",
  CreatePaymentTerms: "Create payment terms",
  Value: "Value",
  AgentReports: "Agent reports",
  PaidToTheAgent: "Paid to the agent",
  PaidFrom: "Paid from",
  PaidTill: "Paid till",
  TermsOfPaymentToTheAgent: "Terms of payment to the agent",
  Received: "Received",
  Agency: "Agency",
  ConditionList: "Condition list",
  LicenseList: "List of licenses",
  AmountOfWorkingHoursPerDay: "Amount of working hours per day",
  Calculate: "Calculate",
  Weekends: "Weekends",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  EditContractor: "Edit contractor",
  Image: "Image",
  PracticeAssignmentPlural: "Practice Assignments",
  LockSettingsDisableCamera: "Lock Settings Disable Camera",
  LockSettingsDisableMicrophone: "Lock Settings Disable Microphone",
  LockSettingsDisablePublicChat: "Lock Settings Disable Public Chat",
  ChangeView: "Change view",
  ContractorCreate: "Create contractor",
  SuccessfullyCompleteTheProgressOfTheTraining:
    "Successfully complete the progress of the training when transferring the application to the status of «Training completed»Successfully complete the progress of the training when transferring the application to the status of «Training completed»",
  InsertTable: "Insert table",
  AddColumnBefore: "Add column before",
  AddColumnAfter: "Add column after",
  DeleteColumn: "Delete column",
  AddRowBefore: "Add row before",
  AddRowAfter: "Add row after",
  DeleteRow: "Delete row",
  DeleteTable: "Delete table",
  MergeCells: "Merge cells",
  SplitCell: "Split cell",
  ToggleHeaderColumn: "Toggle header column",
  ToggleHeaderRow: "Toggle header row",
  ToggleHeaderCell: "Toggle header cell",
  MergeOrSplit: "Merge or split",
  SetCellAttribute: "Set cell attribute",
  FixTables: "Fix tables",
  GoToNextCell: "Go to next cell",
  GoToPreviousCell: "Go to previous cell",
  ClearFinalDocumentExport:
    "Are you sure you want to clear the upload to FIS FRDO?",
  Instructions: "Instructions",
  Accounting: "Accounting",
  InProgress: "In progress",
  CloseAccessToTrainingMaterials: "Close access to training materials",
  RequestAmount: "Request Amount",
  ListOfLicenses: "List of licenses",
  StudentDocuments: "Student documents",
  YouCanOnlyAddStudentsToAGroupWithTheStatusLearning:
    "You can only add students to a group with the status «Learning»",
  Send: "Send",
  Chats: "Chats",
  NoMessages: "No messages",
  ToMyAccount: "To my account",
  ToOtherAccounts: "To other accounts",
  UserDoesNotHaveAccessToYourAccount:
    "User does not have access to your account",
  TheUserHasAccessToYourAccount: "The user has access to your account",
  UserAccesses: "User accesses",
  MyAccesses: "My accesses",
  Provide: "Provide",
  YouHaveAccessToTheUser: "You have access to the user",
  YouDoNotHaveAccessToTheUser: "You do not have access to the user",
  Request: "Request",
  YouAreUnderADifferentAccountAndYouWillAutomaticallyReturnToYourAccountThrough:
    "You are under a different account. And you will automatically return to your account through",
  Read: "Read",
  NotRead: "Not read",
  Header: "Header",
  Body: "Body",
  Footer: "Footer",
  NewDeal: "New deal",
  PassingTheTestSuccessfully: "Passing the test successfully",
  EnrollmentInTheCourse: "Enrollment in the course",
  BelowYouCanChangeTheMessagesSentToUsersOnTheSiteOrByEmailClearTheFieldsIfYouWantToLeaveTheDefaultNotificationText:
    "Below you can change the messages sent to users on the site or by email. Clear the fields if you want to leave the default notification text.",
  AvailableTokens: "Available tokens",
  MarkAsRead: "Mark as read",
  NoNewNotifications: "No new notifications",
  ViewAllNotifications: "View all notifications",
  Notifications: "Notifications",
  IntoTheSystem: "Into the system",
  EmailNotifications: "Email notifications",
  NotificationTemplates: "Notification templates",
  Agreed: "Agreed",
  DidNotAgree: "Did not agree",
  YouAreGrantedAccessToTheAccount: "You are granted access to the account",
  WantsAccessToYourAccount: "wants access to your account",
  AccessToTheAccountGasBeenRequestedPleaseWait:
    "Access to the account has been requested, please wait.",
  SystemSupport: "Tech Support",
  CompanySupport: "Support",
  WriteMessage: "Write a message",
  ChooseStaffMemberToAnswerGeneralStudentQuestions:
    "Choose a staff member to answer general student questions.",
  TheFileHasBeenImportedYouCanSeeTheNumbersInTheListOfStudentsInTheTrainingProtocol:
    "The file has been imported. You can see the numbers in the list of students in the training protocol.",
  ImportSummary: "Import summary",
  EmailFullNameSnilsOrPhone:
    "Email, Full name, Individual insurance account number (SNILS) or Phone",
  ExistStudentMessage: "A student with this full name and SNILS exists",
  RecentFiles: "Recent files",
  OpenFullScreen: "Open full screen",
  TryTheNewInterfaceLabel: "Try the new interface",
  TryTheNewInterfaceText:
    "We updated the design and added a lot of new features. It will become the main interface in the near future. If there are any problems, you can return to the previous interface by clicking the icon again.",
  ChangeApplicationVersion: "Change application version",
  CreateAtLeastOneFinalDocument: "Create at least one final document",
  RecordWebinar: "Record webinar",
  UpdateJournal: "Update the e-journal",
  Progress: "Progress",
  LessonBlock: "Lesson block",
  ShowCorrectAnswers: "Show correct answers",
  NDS: "VAT",
  WithOutNDS: "Without VAT",
  AskQuestion: "Ask a question",
  FreeNavigationCourseLabelIcon:
    "If «No» is selected, then the student will only be able to study materials in course. Once saved, the setting will apply to all lessons in the course. To change this, use a similar setting in the lessons themselves.",
  YouHaveNotBeenGrantedAccessToTheLessonStudy:
    "You have not been granted access to the lesson study",
  FreeMovementIsNotAllowedStudyThePreviousLessons:
    "Free movement is not allowed. Study the previous lessons",
  LaborProtectionWorker: "Labor protection workers",
  LaborProtection: "Labor protection",
  ShowDetails: "Show details",
  Errors: "Errors",
  ErrorsWereFoundInTheFollowingLinesFixThemAndStartImportingAgain:
    "Errors were found in the following lines. Fix them and start importing again.",
  Line: "Line",
  OrdersAlreadyCreated: "Orders already created",
  AddToTheOrder: "Add to the order",
  ScopeOfActivity: "Scope of activity",
  YourCurrentVersion: "Your current version",
  CountOfVariantsAndQuestions: "Count of variants and questions",
  CountOfVariants: "Count of variants",
  CountOfQuestions: "Count of questions",
  Variant: "Variant",
  DifficultyLevel: "Difficulty level",
  Easy: "Easy",
  Medium: "Medium",
  Hard: "Hard",
  AnyAnswerIsCorrect: "Any answer is correct",
  SettingPointsForPassing: "Setting points for passing",
  MinimumNumberOfCorrectAnswers: "Minimum number of correct answers",
  InRandomOrder: "In random order",
  ByComplexity: "By complexity",
  ByVariants: "By variants list",
  EditContent: "Edit content",
  YouCanPractiseTakingTheTestByClickingOnThePracticeTest:
    "You can practise taking the test by clicking on the Practice Test",
  ShowCorrectAnswersAfterPassing: "Show correct answers after passing",
  TestFormVariantsInfo:
    "There can be several variants of the test. When you take the test, it will be selected at random. If this is not necessary, create only one.",
  SortVariants: "Sort variants",
  Alignment: "Alignment",
  Small: "Small",
  Large: "Large",
  Fullscreen: "Full screen",
  Left: "Left",
  Right: "Right",
  Center: "Center",
  Regular: "Regular",
  ChooseWhatHappensWhenTheRequestMovesToThisStatus:
    "Choose what happens when the request moves to this status",
  SelectTheStatusesToWhichTheApplicationCanBeTransferredFromThisStatus:
    "Select the statuses to which the application can be transferred from this status",
  Schedule: "Schedule",
  Desk: "Desk",
  WebCamera: "Web-camera",
  FullRecord: "Full record",
  NoRecordedWebinarsFound: "No recorded webinars found",
  CheckWebinarRecords: "Check webinar records",
  NewSlide: "New slide",
  NewVideo: "New video",
  Imports: "Imports",
  SelectACourseAndContractor: "Select a course and contractor",
  TheFoundStudentsHaveSeveralContractorsPleaseSelectTheOneYouNeedAndContinueExporting:
    "The found students have several contractors. Please select the one you need and continue exporting.",
  Minute: "Minute | Minutes | Minutes",
  ToEvaluateTheStudentPracticeYouMustGoToTheDesiredSession:
    "To evaluate the student's practice, you must go to the desired session",
  AdvancedEditor: "Advanced editor",
  Positions: "Positions",
  AgentPaymentAt: "Agent Payment At",
  SuccessfullyRegistered: "SuccessfullyRegistered",
  StatusOfYourStudy: "Status of your study",
  StudyOfMaterials: "Study of materials",
  SpecifyTheSource: "Specify the source",
  SelectStatusGroup: "Select a status group",
  TheStudentHasNotYetBeenGrantedAccessTraining:
    "The student has not yet been granted access to training",
  CompanyTimeSet: "The time is set relative to the company's time zone",
  ToTheTableOfContents: "To the table of contents",
  NoServerConnectionTryLater:
    "No connection to the server. Try again after a few minutes. If the error continues, check the connection",
  NotPublished: "Not published",
  AccountAsLogin: "Account",
  GrantAccessByEmail: "Grant access by Email",
  ExpirationDate: "Expiration date",
  ChangesYouMadeMayNotBeSaved: "Changes you made may not be saved",
  Director: "Director",
  Exit: "Exit",
  GenerateXML: "Generate XML",
  FISFRDOunloaded: "FIS FRDO unloaded",
  FISFRDOunloadedFrom: "FIS FRDO unloaded from",
  FileTypeFISFRDO: "File type FIS FRDO",
  HomePage: "Home page",
  ChangeUserName: "Change user name",
  MyTraining: "My training",
};
